import { render, staticRenderFns } from "./stat-story.vue?vue&type=template&id=0c2d46cc&scoped=true&"
import script from "./stat-story.vue?vue&type=script&lang=js&"
export * from "./stat-story.vue?vue&type=script&lang=js&"
import style0 from "./stat-story.vue?vue&type=style&index=0&id=0c2d46cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d46cc",
  null
  
)

export default component.exports